module.exports = __webpack_public_path__ + "static/media/js.b0dfe440.svg";